<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
import type { ISitemapRemap } from '~/interfaces/dto/sitemap/response';
defineProps<{
  bindingClass: (string | Record<string, boolean>)[];
  dropDownActive: boolean;
  navigationLink: Partial<ISitemapRemap>;
  isActive: boolean;
}>();
const emits = defineEmits<{
  (e: 'navigate', alias: string): void;
}>();
</script>

<template>
  <NuxtLink
    :id="`${navigationLink.Alias}-nav-item`"
    :key="navigationLink.Alias"
    :to="navigationLink.Path"
    :class="bindingClass"
    @click="emits('navigate', navigationLink.Alias)"
  >
    <Button
      class="flex-col"
      :element-name="`page-link-${navigationLink.Alias}`"
      :class="{
        'w-4/5': dropDownActive,
        '!w-full md:!w-fit': !dropDownActive,
      }"
      rounding="md"
      padding="md"
      :type="isActive ? 'primary' : 'transparent'"
    >
      <DesignSystemIconsExternalIcon
        :icon-name="navigationLink.Alias"
        :class="{ 'invert-0': isActive }"
        class="w-6 h-6"
      />
      <span
        class="capitalize w-full text-xxs"
        :class="{
          'line-clamp-2 min-w-fit': dropDownActive,
          'truncate text-ellipsis': !dropDownActive,
        }"
      >
        {{ $t(`vertical.${navigationLink.Alias}`) }}
      </span>
    </Button>
  </NuxtLink>
</template>
